<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zyQ3jL/images/Cover.jpg?1702297693303" alt="This image is the cover for the book Deadline"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Deadline
      </h1>
      <p class="bookDescription body article font2">
        <p>Jack McMorrow, a former <i>New York Times</i> reporter has come to Maine to run the weekly local newspaper. When a seemingly friendless and ineffective staff photographer is found drowned in the river, McMorrow wonders why, and wonders why the local police don't wonder more.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gerry Boyle
      </h2>
      
      <p class="authorDescription body article">Gerry Boyle began his writing career working for newspapers—a start he calls the best training ground ever. After attending Colby College, he knocked around at various jobs, including stints as a roofer, a postman, and a manuscript reader at a big New York publisher. He began his newspaper career in the paper mill town of Rumford, Maine. There was a lot of small-town crime in Rumford and Gerry would later mine his Rumford time for his first novel, <i>Deadline</i> After a few months he moved on to the <i>Morning Sentinel</i> in Waterville, where editors gave him a thrice-weekly column and he wrote about stuff he saw in police stations and courtrooms in the towns and cities of Maine. All the while he was also typing away on a Smith-Corona electric typewriter, writing <i>Deadline</i> which marked his debut s a novelist in 1993. Since finishing <i>Deadline</i>, he has written eight additional Jack McMorrow stories with a tenth, <i>Once Burned</i>, scheduled for release in May 2015.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Islandport Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?521977ba